"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Button_1 = __importDefault(require("../Button"));
exports.default = react_1.forwardRef(function SimpleDialogAction(_a, ref) {
    var title = _a.title, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick, _c = _a.isDestructive, isDestructive = _c === void 0 ? false : _c, _d = _a.isDefault, isDefault = _d === void 0 ? false : _d;
    var variant;
    var color = 'primary';
    if (isDefault) {
        variant = 'contained';
        color = 'primary';
    }
    if (isDestructive) {
        color = 'secondary';
        variant = 'contained';
    }
    return (jsx_runtime_1.jsx(Button_1.default, __assign({ disabled: disabled, variant: variant, color: color, onClick: onClick, ref: ref }, { children: title }), void 0));
});
//# sourceMappingURL=SimpleDialogAction.js.map